<template>
  <b-row id="healthmentalcare" class="section-invert reverse-sm">
    <b-col md="12" lg="6" class="content my-auto">
      <h3>{{ $t("carementalhealth.title") }}</h3>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list mt-sm-5">
          <div>
            <p>
              <v-icon large v-text="'mdi-meditation'"></v-icon
              >{{ $t("carementalhealth.yoga") }}
              </p>
          </div>
        <div>
            <p style="fontSize:1rem;margin-left:5rem">{{ $t("carementalhealth.yogatext") }}</p>
        </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-spa'"></v-icon
              >{{ $t("carementalhealth.mindfulness") }}
            </p>
          </div>
          <div>
            <p style="fontSize:1rem;margin-left:5rem">{{ $t("carementalhealth.mindfulnesstext") }}</p>
        </div>
          <div>
            <p>
              <v-icon
                large
                v-text="'mdi-brightness-2'"
              ></v-icon
              >{{ $t("carementalhealth.dream") }}
            </p>
          </div>
          <div>
            <p style="fontSize:1rem;margin-left:5rem">{{ $t("carementalhealth.dreamtext") }}</p>
        </div>
          <div>
            <p>
              <v-icon large v-text="'mdi-yoga'"></v-icon
              >{{ $t("carementalhealth.pilates") }}
            </p>
          </div>
          <div>
            <p style="fontSize:1rem;margin-left:5rem">{{ $t("carementalhealth.pilatestext") }}</p>
        </div>
        </div>
      </div>
    </b-col>
    <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
  </b-row>
</template>

<script>
import es from '@/lang/es/public/views/mindfulness.json'
import en from '@/lang/en/public/views/mindfulness.json'

  export default {
     i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  }
  }
</script>

<style lang="scss">

  @import "../../../static-appopensalud/css/public/layout.scss";
  #healthmentalcare .col-bg {
    background-image: url(/static-appopensalud/img/bgs/opt/saludmental2.jpg);
    background-position: center;
    background-blend-mode: overlay;
  }
  @media (max-width: 1268px) {
    #healthmentalcare
      > div.content.my-auto.col-md-12.col-lg-6
      > div
      > div
      > div
      > p {
      font-size: 1rem;
    }
  }
  .btn-more-info-white {
    span {
        color: white !important;font-weight:bold; border-color:white;font-size:0.8rem;
      }
  }
   .btn-more-info-white:hover{
    color: #eee;
    background-color: #3238C4;
    border-color: #3238C4;
    span {
      color: #1D1D1E !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/CareMentalHealth.vue